//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { analytics } from "/src/main.js";
import { db } from "../main.js";
export default {
  data() {
    return {
      loaded: false,
      editMode: false,
      showDiagram: false,
      figures: null,
      animationData: null,
      lessonsWithFigure: null,
      annotations: null,
      targetAnnotation: null,
      currentLesson: null,
      playerVars: {
        autoplay: 0,
      },
    };
  },
  watch: {
    async $route() {
      this.lessonsWithFigure = await this.getLessonsWithCurrentFigure();
      this.setVideoVariation(0);
      analytics.logEvent("screen_view", {
        firebase_screen: `${this.$route.path}`,
        firebase_screen_class: "screenClass",
      });
    },
  },
  computed: {
    style() {
      return this.$route.params.style.toLowerCase();
    },
    dance() {
      return this.$route.params.danceid;
    },
    figure() {
      return this.$route.params.figure;
    },
    level() {
      if (this.loaded) {
        const bronzeList = Object.keys(this.figures[this.dance]["Bronze"]);
        const silverList = Object.keys(this.figures[this.dance]["Silver"]);
        const goldList = Object.keys(this.figures[this.dance]["Gold"]);
        return bronzeList.includes(this.figure)
          ? "Bronze"
          : silverList.includes(this.figure)
          ? "Silver"
          : goldList.includes(this.figure)
          ? "Gold"
          : "Newcomer";
      }
      return null;
    },
    figureData() {
      return this.loaded && this.dance && this.level && this.figure
        ? this.figures[this.dance][this.level][this.figure]
        : null;
    },
    path() {
      return [
        {
          label: this.$route.params.style,
          path: { name: "SyllabusStyleDetails" },
        },
        {
          label: this.$route.params.danceid,
          path: { name: "DanceDetails", params: { danceid: this.dance } },
        },
      ];
    },
    initialStartTime() {
      return this.targetAnnotation ? this.targetAnnotation.startTime : 0;
    },
    demoOptions() {
      var arr = [];
      if (this.lessonsWithFigure) {
        this.lessonsWithFigure.forEach((item, idx) => {
          arr.push(`Demo ${idx + 1}`);
        });
      }
      return arr;
    },
  },
  methods: {
    updateFigure(newData) {
      db.ref(
        `${this.style}figures/${this.dance}/${this.level}/${this.figure}`
      ).set(newData);
    },
    updateAnimation(newData) {
      db.ref(`animations/${this.dance}/${this.figure}`).set(newData);
      if (newData) {
        db.ref(
          `${this.style}figures/${this.dance}/${this.level}/${this.figure}/animationType`
        ).set("Lottie");
      }
    },
    toggleDiagramVideo(tab) {
      this.showDiagram = tab === "Diagram" ? true : false;
    },
    async getLessonsWithCurrentFigure() {
      var classesWithFigureStyle = [];
      var lessonsWithFigureDance = [];
      var lesson = {};
      await db
        .ref(`classes`)
        .orderByChild("style")
        .equalTo(this.$route.params.style)
        .once("value", (snapshot) => {
          classesWithFigureStyle = Object.keys(snapshot.val());
        });
      for (let idx in classesWithFigureStyle) {
        await db
          .ref(`lessons/${classesWithFigureStyle[idx]}`)
          .orderByChild("dance")
          .equalTo(this.$route.params.danceid)
          .once("value", (snapshot) => {
            for (const key in snapshot.val()) {
              lesson = {
                ...lesson,
                ...snapshot.val()[key],
                ...{ lessonKey: key },
                ...{ classKey: classesWithFigureStyle[idx] },
              };
              lessonsWithFigureDance.unshift(lesson);
            }
          });
      }
      var lessonHasAnnotation = [];
      if (lessonsWithFigureDance) {
        for (let idx in lessonsWithFigureDance) {
          var annotations = await this.getAnnotations(
            lessonsWithFigureDance[idx].classKey,
            lessonsWithFigureDance[idx].lessonKey
          );
          lessonHasAnnotation.push(
            annotations.some((item) => item.name === this.$route.params.figure)
          );
        }
      }
      var lessonsWithFigure = [];
      lessonHasAnnotation.forEach((hasAnno, idx) => {
        hasAnno ? lessonsWithFigure.push(lessonsWithFigureDance[idx]) : null;
      });
      return lessonsWithFigure;
    },
    async getAnnotations(classKey, lessonKey) {
      var annotations;
      await db
        .ref(`annotations/${classKey}/${lessonKey}`)
        .orderByChild("startTime")
        .once("value", (snapshot) => {
          annotations = Object.values(snapshot.val());
        });
      return annotations;
    },
    handleSelect(selected) {
      this.setVideoVariation(this.demoOptions.indexOf(selected));
    },
    async setVideoVariation(idx) {
      this.currentLesson = this.lessonsWithFigure[idx];
      if (this.currentLesson) {
        const { classKey, lessonKey } = this.currentLesson;
        this.annotations = await this.getAnnotations(classKey, lessonKey);
        this.targetAnnotation = this.annotations.find(
          (anno) => anno.name === this.$route.params.figure
        );
      }
    },
  },
  async created() {
    analytics.logEvent("screen_view", {
      firebase_screen: `${this.$route.path}`,
      firebase_screen_class: "screenClass",
    });
    await db
      .ref(`animations/${this.dance}/${this.figure}`)
      .on("value", (snapshot) => {
        if (snapshot.exists()) {
          this.animationData = snapshot.val();
        }
      });
    await db
      .ref(`${this.style}figures`)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          this.figures = snapshot.val();
        }
      });
    this.lessonsWithFigure = await this.getLessonsWithCurrentFigure();
    this.setVideoVariation(0);
    this.loaded = true;
  },
};
